module.exports = __webpack_public_path__ + "img/home_selected.501b4855.svg";